<template>
  <section class="section-title"
           :class="padding">
    <h2 class="section-title__headline"
        v-html="sectionTitle.title"></h2>
  </section>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    sectionTitle: {
      type: Object,
      default: function () {
        return {
          title: 'TITLE',
        }
      }
    },
    padding: {
      type: String,
      default: "'section-title--full-padding'"
    },
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
